import { gql } from "@apollo/client";
import { DEDUCTION_FRAGMENT } from "./deductionFragment";

const GET_ACCOUNTING_DATA = gql`
  ${DEDUCTION_FRAGMENT}
  query GetAccountingData($params: GetAccountingDataParams!) {
    getAccountingData(params: $params) {
      total
      page
      limit
      items {
        ...DeductionFields
      }
      columns {
        key
        title
      }
    }
  }
`;

export default GET_ACCOUNTING_DATA;